var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconApplications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0f4b73;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-717 -388)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 29,
    cy: 29,
    r: 29,
    transform: "translate(717 388)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M450.114,180.41H440a3.468,3.468,0,0,1-3.468-3.468V166.826a.289.289,0,0,0-.289-.289h-6.647a4.624,4.624,0,0,0-4.624,4.624v23.121a4.624,4.624,0,0,0,4.624,4.624h16.185a4.624,4.624,0,0,0,4.624-4.624V180.7A.289.289,0,0,0,450.114,180.41Zm-6.647,11.56h-11.56a1.156,1.156,0,0,1,0-2.312h11.56a1.156,1.156,0,0,1,0,2.312Zm0-5.78h-11.56a1.156,1.156,0,0,1,0-2.312h11.56a1.156,1.156,0,0,1,0,2.312Z",
    transform: "translate(308.313 234.278)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M458.09,178.4,447.7,168.007a.145.145,0,0,0-.246.1v9.379a1.156,1.156,0,0,0,1.156,1.156h9.379a.145.145,0,0,0,.1-.246Z",
    transform: "translate(299.703 233.731)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApplications);
export default __webpack_public_path__ + "static/media/icon-Applications.413fef8c4c4c7411e269ba122ef55cf5.svg";
export { ForwardRef as ReactComponent };